var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "trial-end-clock",
        {
          attrs: {
            "img-src": "elapsed-time-red",
            title: _vm.$t.__("common.labels.inactive_account"),
            subtitles: [
              _vm.$t.__(
                "pages.errors.TrialEndCartAvailable.thanks_valide_offer"
              )
            ]
          }
        },
        [
          _c("CompassButton", {
            attrs: { size: "large", label: _vm.buttonLabel },
            on: { click: _vm.goToCartLink }
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "typographies-paragraph-medium-semibold help-message__container"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$l10n.__("Besoin d’aide ?")) +
                  "\n            "
              ),
              _c("CompassLink", {
                attrs: {
                  label: _vm.$t.__(
                    "pages.errors.TrialEndCartAvailable.contact_support"
                  ),
                  link: "javascript:;"
                },
                on: { click: _vm.contactSale }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }